/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getCompanyAddressV2Details } from "api/services/company";
import { GetCompanyAddressV2DetailsResponseType } from "api/response"; // <-- import the correct type
import { companyQueryKeys } from "./companyQueryKeys";

export function useGetAddressesV2Details(
  reference_number: string,
  params?: {
    options?: UseQueryOptions<any, unknown, GetCompanyAddressV2DetailsResponseType, any>;
    onFetchSuccess?: (address: any) => void;
  },
) {
  return useQuery<GetCompanyAddressV2DetailsResponseType>({
    queryKey: companyQueryKeys.addressV2Details(reference_number, params?.onFetchSuccess),
    queryFn: async () => {
      const res = await getCompanyAddressV2Details(reference_number);
      if (params?.onFetchSuccess) params.onFetchSuccess(res.data);
      return res.data;
    },
    refetchOnMount: false,
    ...(params?.options ?? {}),
  });
}
